import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function SiteFooter() {
  return (
    <footer className="border-t border-background-200/80 bg-accent-950">
      <div className="mx-auto w-full max-w-[1280px] px-4 pb-8 pt-14 md:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <Link to="/" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
                <i className="ri-film-line text-lg"></i>
              </span>
              <span className="leading-tight">
                <span className="block font-heading text-[17px] font-semibold tracking-wide text-foreground-950">夜澜</span>
                <span className="block font-label text-[9px] tracking-[0.24em] text-foreground-500">日韩伦理电影</span>
              </span>
            </Link>
            <p className="mt-5 max-w-md text-[13px] leading-relaxed text-foreground-500">
              一个专注日韩伦理题材的电影资料站。我们整理影片的年份、班底、类型与剧情梗概，帮你在众多作品里快速找到想看的那一部。
            </p>
            <p className="mt-5 inline-flex items-center gap-2 rounded-md border border-primary-800/60 bg-primary-950/40 px-3 py-1.5 text-[11px] text-primary-300">
              <i className="ri-shield-keyhole-line"></i>
              本站内容仅限 18 岁以上成年观众浏览
            </p>
          </div>

          <div className="md:col-span-2">
            <h3 className="mb-4 text-[13px] font-semibold text-foreground-800">分类目录</h3>
            <ul className="flex flex-col gap-2.5">
              {categories.map((category) => (
                <li key={category.key}>
                  <Link
                    to={`/category/${category.key}`}
                    className="text-[12.5px] text-foreground-500 transition-colors hover:text-primary-300"
                  >
                    {category.label}电影
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h3 className="mb-4 text-[13px] font-semibold text-foreground-800">站内导航</h3>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/" className="text-[12.5px] text-foreground-500 transition-colors hover:text-primary-300">首页</Link>
              </li>
              <li>
                <Link to="/search?q=" className="text-[12.5px] text-foreground-500 transition-colors hover:text-primary-300">站内搜索</Link>
              </li>
              <li>
                <Link to="/favorites" className="text-[12.5px] text-foreground-500 transition-colors hover:text-primary-300">我的收藏</Link>
              </li>
              <li>
                <Link to="/about" className="text-[12.5px] text-foreground-500 transition-colors hover:text-primary-300">关于我们</Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h3 className="mb-4 text-[13px] font-semibold text-foreground-800">内容声明</h3>
            <p className="text-[12.5px] leading-relaxed text-foreground-500">
              本站仅提供影片资料与剧情介绍，不提供任何在线播放、下载或付费服务。所有影片信息仅作资料整理与推荐之用，请支持正版发行。
            </p>
            <a
              href="mailto:hello@yelan-films.example"
              className="mt-4 inline-flex items-center gap-1.5 font-label text-[12px] text-secondary-300 transition-colors hover:text-secondary-200"
            >
              <i className="ri-mail-line"></i>
              hello@yelan-films.example
            </a>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-200/50 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-label text-[11px] text-foreground-500">
            © 2026 夜澜 · 日韩伦理电影资料站　内容仅供学习与交流
          </p>
          <p className="flex flex-wrap items-center gap-3 font-label text-[11px] text-foreground-500">
            <span>虚构演示数据</span>
            <span className="h-2.5 w-px bg-background-300"></span>
            <span>无播放功能</span>
            <span className="h-2.5 w-px bg-background-300"></span>
            <span>仅限成人浏览</span>
          </p>
        </div>
      </div>
    </footer>
  );
}